import type React from 'react'

const IconRefresh: React.FC = () => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.55078 3.44727C3.18555 3.83398 2.90625 4.26367 2.75586 4.73633C2.62695 5.10156 2.21875 5.29492 1.875 5.16602C1.50977 5.03711 1.31641 4.65039 1.44531 4.28516C1.68164 3.61914 2.06836 2.99609 2.58398 2.48047C4.45312 0.611328 7.48242 0.611328 9.37305 2.45898L10.2754 1.55664C10.4043 1.42773 10.6406 1.38477 10.834 1.44922C11.0273 1.53516 11.1562 1.72852 11.1562 1.92188V4.67188C11.1562 4.97266 10.9199 5.1875 10.6406 5.1875H10.4473H7.89062C7.67578 5.1875 7.48242 5.08008 7.39648 4.88672C7.33203 4.69336 7.375 4.45703 7.52539 4.30664L8.40625 3.42578C7.05273 2.11523 4.9043 2.11523 3.55078 3.44727ZM0.84375 7.07812C0.84375 6.79883 1.05859 6.5625 1.35938 6.5625H1.50977H1.53125H4.10938C4.30273 6.5625 4.49609 6.69141 4.58203 6.88477C4.64648 7.07812 4.60352 7.31445 4.47461 7.44336L3.57227 8.3457C4.92578 9.65625 7.0957 9.65625 8.42773 8.32422C8.79297 7.9375 9.07227 7.50781 9.24414 7.03516C9.35156 6.66992 9.75977 6.47656 10.1035 6.60547C10.4688 6.73438 10.6621 7.12109 10.5332 7.48633C10.2969 8.15234 9.91016 8.75391 9.39453 9.29102C7.52539 11.1602 4.49609 11.1602 2.60547 9.3125L1.72461 10.1934C1.57422 10.3438 1.33789 10.3867 1.14453 10.3223C0.951172 10.2363 0.84375 10.043 0.84375 9.82812V7.27148V7.25V7.07812Z"
      fill="currentColor"
    />
  </svg>
)

export default IconRefresh
